import * as React from 'react';
import { Provider } from 'react-redux';
import { browserHistory, IndexRoute, Route, Router } from 'react-router';

import { App } from './App';
import { setTopNavigationActiveStateAction } from './common/components/topNavigation/actions/fetchTopNavigationMenuItems';
import { ArchiveNewsPageContainer } from './components/archiveNewsPage/archiveNewsPageContainer';
import { CertificatesPageContainer } from './components/certificatesPage/certificatesPageContainer';
import { CompetencesPageContainer } from './components/competencesPage/competencesPageContainer';
import { CommonContentPageContainer } from './components/contentPage/contentPageContainer';
import { EventPageContainer } from './components/eventPage/eventPageContainer';
import { EventsArchivePageContainer } from './components/eventsArchivePage/eventsArchivePageContainer';
import { Frontpage } from './components/frontpage';
import { NewsListPageContainer } from './components/newsListPage/newsListPageContainer';
import { NewsPageContainer } from './components/newsPage/newsPageContainer';
import { NotFoundPage } from './components/notFound';
import { installCtaTracking } from './ctaTracking';
import { store } from './store';

const handleUpdate = () => {
  try {
    const path = browserHistory.getCurrentLocation().pathname || window.location.pathname;
    store.dispatch(setTopNavigationActiveStateAction(path));
  } catch (e) { /* swallow: UI state update should never block nav */ }

  try {
    const w: any = window as any;
    if (w && w.snoobi && typeof w.snoobi.trackPageView === 'function') {
      w.snoobi.trackPageView(window.location.href);
    }
  } catch (e) { /* swallow: analytics optional */ }

  try {
    const w2: any = window as any;
    if (w2 && w2._elq && typeof w2._elq.trackEvent === 'function') {
      w2._elq.trackEvent(window.location.href);
    }
  } catch (e) { /* swallow: analytics optional */ }
};

installCtaTracking();


export const AppRouter: React.StatelessComponent<{}> = () => (
  <Provider store={store}>
    <Router history={browserHistory} onUpdate={handleUpdate}>
      <Route path="/" component={App}>
        <IndexRoute component={Frontpage} />
        <Route path="/ajankohtaista" component={NewsListPageContainer} />
        <Route path="/ajankohtaista(/:categories)" component={NewsListPageContainer} />
        <Route path="/uutiset/ajankohtaista(/:categories)" component={ArchiveNewsPageContainer} />
        <Route path="/uutiset/:id" component={NewsPageContainer} />
        <Route path="/tapahtumat/ajankohtaista(/:categories)" component={EventsArchivePageContainer} />
        <Route path="/tapahtumat/:id" component={EventPageContainer} />
        <Route path="/loyda_ammattilainen" component={CommonContentPageContainer} />
        <Route path="/loyda_ammattilainen/:id" component={CommonContentPageContainer} />
        <Route path="/loyda_ammattilainen/**/:id" component={CommonContentPageContainer} />
        <Route path="/haluan_sertifikaatin" component={CommonContentPageContainer} />
        <Route path="/haluan_sertifikaatin/:id" component={CommonContentPageContainer} />
        <Route path="/haluan_sertifikaatin/**/:id" component={CommonContentPageContainer} />
        <Route path="/sertifikaatit" component={CertificatesPageContainer} />
        <Route path="/sertifikaatit/:id" component={CommonContentPageContainer} />
        <Route path="/sertifikaatit/**/:id" component={CommonContentPageContainer} />
        <Route path="/ota_yhteytta" component={CommonContentPageContainer} />
        <Route path="/ota_yhteytta/:id" component={CommonContentPageContainer} />
        <Route path="/ota_yhteytta/**/:id" component={CommonContentPageContainer} />
        <Route path="/patevyydet" component={CompetencesPageContainer} />
        <Route path="/patevyydet/:id" component={CommonContentPageContainer} />
        <Route path="/patevyydet/**/:id" component={CommonContentPageContainer} />
        <Route path="*" component={NotFoundPage} />
      </Route>
    </Router>
  </Provider>
);



// WEBPACK FOOTER //
// ./src/router.tsx